// export const API_URL = 'http://localhost:3003';
// export const API_URL = 'http://localhost:3006';
// export const token = () => localStorage.getItem('token');
export const token = () => localStorage.getItem('token')?.split('').reverse().join('') || null;
export const API_URL = 'https://srv702611.hstgr.cloud:3003';